import React from 'react';
import { Quote } from 'lucide-react';
import { useInViewAnimation } from '../hooks/useInViewAnimation';
import { AnimatedDashboard } from './AnimatedDashboard';

export function TestimonialSection() {
  const { ref, isInView } = useInViewAnimation();

  return (
    <section
      ref={ref}
      className="py-14 md:py-20 px-6 max-w-3xl mx-auto flex flex-col items-center text-center overflow-hidden"
    >
      <Quote
        className={`w-6 h-6 text-[#4C1D95] mb-6 ${isInView ? 'animate-fade-in-up' : 'opacity-0'}`}
        style={{ animationDelay: '0.1s' }}
      />

      <h2
        className={`text-[32px] md:text-[40px] lg:text-[44px] leading-[1.1] text-[#0D212C] tracking-tight mb-6 ${isInView ? 'animate-fade-in-up' : 'opacity-0'}`}
        style={{ animationDelay: '0.2s' }}
      >
        &lsquo;Your <span className="font-serif grad-text">Imagination.</span> Our <span className="font-serif grad-text">Creation.</span>&rsquo;
      </h2>

      <p
        className={`font-mono text-[11px] tracking-widest uppercase text-[#4C1D95] mb-10 ${isInView ? 'animate-fade-in-up' : 'opacity-0'}`}
        style={{ animationDelay: '0.3s' }}
      >
        YP Nova · Enterprise AI &amp; Software Engineering
      </p>

      {/* Cloud partners row */}
      <div
        className={`flex items-center justify-center gap-8 md:gap-12 mb-12 ${isInView ? 'animate-fade-in-up' : 'opacity-0'}`}
        style={{ animationDelay: '0.4s' }}
      >
        {['AWS', 'Azure', 'GCP', 'OpenAI'].map((c) => (
          <span
            key={c}
            className="font-mono text-lg md:text-xl font-medium text-[#0D212C] hover:text-[#4C1D95] transition-colors"
          >
            {c}
          </span>
        ))}
      </div>

      {/* Animated dashboard replaces the old parallax photo */}
      <div
        className={`w-full ${isInView ? 'animate-fade-in-up' : 'opacity-0'}`}
        style={{ animationDelay: '0.5s' }}
      >
        <AnimatedDashboard />
      </div>
    </section>
  );
}
